import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

type CompanyInfo = {
  postal_code?: string | null;
  address?: string | null;
  phone?: string | null;
  representative_name?: string | null;
  email?: string | null;
};

interface Props {
  content: any; // GraphQLのJSON型
  fetchedAt: string;
}

export default ({content, fetchedAt}: Props) => {
  const companyInfo = content as CompanyInfo;
  return (
    <Container>
      <FetchedAt>
        最終取得日: {moment(fetchedAt).format('YYYY/MM/DD HH:mm')}
      </FetchedAt>
      <InfoContainer>
        <Section>
          <Label>郵便番号</Label>
          <Value>{companyInfo.postal_code || '情報なし'}</Value>
        </Section>
        <Section>
          <Label>住所</Label>
          <Value>{companyInfo.address || '情報なし'}</Value>
        </Section>
        <Section>
          <Label>代表電話</Label>
          <Value>{companyInfo.phone || '情報なし'}</Value>
        </Section>
        <Section>
          <Label>代表者名</Label>
          <Value>{companyInfo.representative_name || '情報なし'}</Value>
        </Section>
        <Section>
          <Label>メールアドレス</Label>
          <Value>{companyInfo.email || '情報なし'}</Value>
        </Section>
      </InfoContainer>
    </Container>
  );
};

const Container = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const FetchedAt = styled.div`
  font-size: 11px;
  color: var(--text-color-3);
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-color);
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Label = styled.div`
  font-size: 11px;
  font-weight: bold;
  color: var(--text-color-3);
  line-height: 1.5em;
`;

const Value = styled.div`
  font-size: 12px;
  line-height: 1.5em;
  color: var(--text-color-1);
  word-break: break-all;
`;
